import './TextInput.scss';

import cn from 'classnames';
import React, {
  forwardRef,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';

import {
  TextInputDefaultProps,
  TextInputPropTypes,
} from './TextInput.proptypes';

const TextInput = forwardRef(
  (
    {
      autoComplete,
      autoFocus,
      className,
      context,
      disabled,
      errors,
      id,
      max,
      maxLength,
      min,
      minLength,
      name,
      onBlur,
      onChange,
      onClick,
      onFocus,
      onKeyDown,
      placeholder,
      readOnly,
      required,
      revealed,
      spellCheck,
      type,
      value,
      variant,
    },
    ref,
  ) => {
    const [inputValue, setInputValue] = useState(value);

    useEffect(() => setInputValue(value), [value]);

    const handleChange = useCallback(
      (e) => {
        setInputValue(e.target.value);
        onChange(e);
      },
      [onChange],
    );

    const conditionalProps = useMemo(
      () => ({
        ...(id ? { id } : {}),
        ...{
          'data-qa-id': `${context || 'input-text'}-${
            disabled ? 'disabled' : 'active'
          }`,
        },
      }),
      [context, disabled, id],
    );

    return (
      <input
        ref={ref}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...conditionalProps}
        autoComplete={autoComplete}
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus={autoFocus}
        className={cn('text-input', `text-input--${type}`, className, {
          'text-input--disabled': disabled || readOnly,
          [`text-input--${variant}`]: variant,
          'text-input--error': errors,
        })}
        disabled={disabled}
        max={max}
        maxLength={maxLength}
        min={min}
        minLength={minLength}
        name={name || id}
        onBlur={onBlur}
        onChange={handleChange}
        onClick={onClick}
        onFocus={onFocus}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        readOnly={readOnly}
        required={required}
        spellCheck={spellCheck}
        type={type === 'password' && revealed ? 'text' : type}
        value={inputValue}
      />
    );
  },
);

TextInput.defaultProps = {
  ...TextInputDefaultProps,
};

TextInput.propTypes = {
  ...TextInputPropTypes,
};

export default TextInput;
